export function addYears(date: Date, years: number): Date {
    date.setFullYear(date.getFullYear() + years);
    return date;
}

export function addMonth(date: Date, month: number): Date {
    date.setMonth(date.getMonth() + month);
    return date;
}

export function addDays(date: Date, days: number): Date {
    date.setDate(date.getDate() + days);
    return date;
}